/**
 * Maps apiConfig keys → Runtime web action path segment (under package in app.config.yaml).
 * Used with SURPRISE_WEB_ACTIONS_BASE or the default same-origin /api/v1/web/prj-testkitchen base.
 */
export const SURPRISE_ACTION_PATHS = {
  generateImage: 'surprise-generate-image',
  generateImageWithReference: 'surprise-generate-image-with-reference',
  generateAxisScales: 'surprise-generate-axis-scales',
  analyzeContent: 'surprise-analyze-content',
  generateCombinedImage: 'surprise-generate-combined-image',
  extractColors: 'surprise-extract-colors',
  analyzeCircle: 'surprise-analyze-circle',
  getAbstractConcepts: 'surprise-get-abstract-concepts',
  decomposeImage: 'surprise-decompose-image',
  logMoodboardImage: 'surprise-log-moodboard-image',
  proxyImage: 'surprise-proxy-image'
}

/** process.env keys for per-action URL overrides (optional). */
export const SURPRISE_URL_ENV_KEYS = {
  generateImage: 'SURPRISE_URL_GENERATE_IMAGE',
  generateImageWithReference: 'SURPRISE_URL_GENERATE_IMAGE_WITH_REFERENCE',
  generateAxisScales: 'SURPRISE_URL_GENERATE_AXIS_SCALES',
  analyzeContent: 'SURPRISE_URL_ANALYZE_CONTENT',
  generateCombinedImage: 'SURPRISE_URL_GENERATE_COMBINED_IMAGE',
  extractColors: 'SURPRISE_URL_EXTRACT_COLORS',
  analyzeCircle: 'SURPRISE_URL_ANALYZE_CIRCLE',
  getAbstractConcepts: 'SURPRISE_URL_GET_ABSTRACT_CONCEPTS',
  decomposeImage: 'SURPRISE_URL_DECOMPOSE_IMAGE',
  logMoodboardImage: 'SURPRISE_URL_LOG_MOODBOARD_IMAGE',
  proxyImage: 'SURPRISE_URL_PROXY_IMAGE'
}
